import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { EventsService } from 'src/app/services/events-service/events.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { EMPTY } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-events-events-dashboard',
  templateUrl: './events-events-dashboard.component.html',
  styleUrls: ['./events-events-dashboard.component.scss']
})
export class EventsEventsDashboardComponent implements OnInit, OnDestroy {

  alerts;
  filterKey;
  filterOpts;
  noItemsConfig;
  viewDisposition = 'grid';
  getAlertsSubscriptionRefresh: Subscription;
  searchAlertsSubscription: Subscription;
  filterAlertsSubscription: Subscription;
  getAlertsSubscription: Subscription;
  toggleEventsDispositionSubscription: Subscription;

  constructor(private eventsService: EventsService,
              private snackbarService: SnackBarService,
              private cd: ChangeDetectorRef,
              private headerBreadcrumbService: HeaderBreadcrumbService) {
              this.noItemsConfig = this.setNoItemsConfig();
            }

  ngOnInit() {
    this.setBreadcrumb();
    this.getAlerts();
    this.getAlertsSubscriptionRefresh = this.eventsService.refreshAlertsListen().subscribe(
      (res) => {
        this.getAlerts();
      }
    );
    this.filterAlertsSubscription = this.eventsService.filterAlertsListen().subscribe(
      (res) => {
        this.filterOpts = res;
        this.cd.detectChanges();
      }
    );
    this.searchAlertsSubscription = this.eventsService.searchAlertsListen().subscribe(
      (res) => {
        this.filterKey = res;
      }
    );
    this.toggleEventsDispositionSubscription = this.eventsService.toggleEventsDispositionListen().subscribe(
      (res) => {
        this.viewDisposition = res;
      }
    );
  }

  public getAlerts() {
    this.getAlertsSubscription = this.eventsService.getAlerts().pipe(
      tap(o => this.alerts = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-exclamation-circle', 'events-page.events', '/account', [new BRoute('account-page.account', '/account'), new BRoute('events-page.events')]));
  }

  private setNoItemsConfig() {
    return {
      description: 'events-page.events not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

  ngOnDestroy() {
    if (this.getAlertsSubscriptionRefresh) { this.getAlertsSubscriptionRefresh.unsubscribe(); }
    if (this.getAlertsSubscription) { this.getAlertsSubscription.unsubscribe(); }
    if (this.searchAlertsSubscription) { this.searchAlertsSubscription.unsubscribe(); }
    if (this.filterAlertsSubscription) { this.filterAlertsSubscription.unsubscribe(); }
    if (this.toggleEventsDispositionSubscription) { this.toggleEventsDispositionSubscription.unsubscribe(); }
  }

}
